module.exports = __webpack_public_path__ + "img/billing.fffe3fe9.png";